/**
 * Показать список ключей и их значений
 */
// I18nDumpTable.jsx
import React, { useMemo } from "react";
import i18n from "../i18n";

function flatten(obj, prefix = "") {
  const out = {};
  if (!obj || typeof obj !== "object") return out;

  for (const [k, v] of Object.entries(obj)) {
    const key = prefix ? `${prefix}.${k}` : k;

    if (typeof v === "string") {
      out[key] = v;
    } else if (v && typeof v === "object") {
      Object.assign(out, flatten(v, key));
    } else if (v != null) {
      out[key] = String(v);
    }
  }
  return out;
}

export function I18nDumpTable() {
  const rows = useMemo(() => {
    // если у тебя есть namespaces, подхватим их; иначе используем "translation"
    const nsList = i18n.options.ns || ["translation"];

    const ruAll = {};
    const enAll = {};

    for (const ns of nsList) {
      const prefix = nsList.length > 1 ? `${ns}:` : "";

      const ruBundle = i18n.getResourceBundle("ru", ns);
      const enBundle = i18n.getResourceBundle("en", ns);

      Object.assign(ruAll, flatten(ruBundle, prefix));
      Object.assign(enAll, flatten(enBundle, prefix));
    }

    const keys = Array.from(
      new Set([...Object.keys(ruAll), ...Object.keys(enAll)])
    ).sort();

    return keys.map((key) => ({
      key,
      ru: ruAll[key] ?? "—",
      en: enAll[key] ?? "—",
    }));
  }, []);

  return (
    <table style={{ borderCollapse: "collapse", width: "100%" }}>
      <thead>
        <tr>
          <th style={{ border: "1px solid #ccc", padding: 6 }}>key</th>
          <th style={{ border: "1px solid #ccc", padding: 6 }}>ru</th>
          <th style={{ border: "1px solid #ccc", padding: 6 }}>en</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.key}>
            <td style={{ border: "1px solid #ccc", padding: 6 }}>{r.key}</td>
            <td style={{ border: "1px solid #ccc", padding: 6 }}>{r.ru}</td>
            <td style={{ border: "1px solid #ccc", padding: 6 }}>{r.en}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
